import { axios } from "../axios";
import { GET, POST } from "../endpoints";

// ============================================================================
// Wellbeing catalogue management (super admin only — manage/* endpoints).
// Every write busts the server cache, so callers refetch lists after a write.
// ============================================================================

// ---- Feelings ----
export const getManageFeelings = async (params) => {
  try {
    return await axios.get(GET.GET_MANAGE_FEELINGS, { params });
  } catch (err) {
    throw err;
  }
};

export const createFeeling = async (payload) => {
  try {
    return await axios.post(POST.MANAGE_FEELINGS, payload);
  } catch (err) {
    throw err;
  }
};

export const updateFeeling = async (id, payload) => {
  try {
    return await axios.post(`${POST.MANAGE_FEELINGS}/${id}`, payload);
  } catch (err) {
    throw err;
  }
};

export const reorderFeelings = async (items) => {
  try {
    return await axios.post(POST.MANAGE_FEELINGS_REORDER, { items });
  } catch (err) {
    throw err;
  }
};

export const setFeelingActive = async (id, isActive) => {
  try {
    return await axios.post(POST.MANAGE_FEELINGS_ACTIVE_DEACTIVE, { id, is_active: isActive });
  } catch (err) {
    throw err;
  }
};

// reasonIds order = per-feeling display order.
export const setFeelingReasons = async (id, reasonIds) => {
  try {
    return await axios.post(`${POST.MANAGE_FEELINGS}/${id}/reasons`, { reason_ids: reasonIds });
  } catch (err) {
    throw err;
  }
};

// Guarded hard delete — 200 if never used, 409 if it has responses (deactivate instead), 404 if already gone.
export const deleteFeeling = async (id) => {
  try {
    return await axios.delete(`${POST.MANAGE_FEELINGS}/${id}`);
  } catch (err) {
    throw err;
  }
};

// ---- Reasons ----
export const getManageReasons = async (params) => {
  try {
    return await axios.get(GET.GET_MANAGE_REASONS, { params });
  } catch (err) {
    throw err;
  }
};

export const createReason = async (payload) => {
  try {
    return await axios.post(POST.MANAGE_REASONS, payload);
  } catch (err) {
    throw err;
  }
};

export const updateReason = async (id, payload) => {
  try {
    return await axios.post(`${POST.MANAGE_REASONS}/${id}`, payload);
  } catch (err) {
    throw err;
  }
};

export const reorderReasons = async (items) => {
  try {
    return await axios.post(POST.MANAGE_REASONS_REORDER, { items });
  } catch (err) {
    throw err;
  }
};

export const setReasonActive = async (id, isActive) => {
  try {
    return await axios.post(POST.MANAGE_REASONS_ACTIVE_DEACTIVE, { id, is_active: isActive });
  } catch (err) {
    throw err;
  }
};

// Guarded hard delete — 200 if never used, 409 if it has responses (deactivate instead), 404 if already gone.
export const deleteReason = async (id) => {
  try {
    return await axios.delete(`${POST.MANAGE_REASONS}/${id}`);
  } catch (err) {
    throw err;
  }
};

// ---- Polarities ----
export const getManagePolarities = async (params) => {
  try {
    return await axios.get(GET.GET_MANAGE_POLARITIES, { params });
  } catch (err) {
    throw err;
  }
};

// code is immutable server-side; only name/sort_order change.
export const updatePolarity = async (id, payload) => {
  try {
    return await axios.post(`${POST.MANAGE_POLARITIES}/${id}`, payload);
  } catch (err) {
    throw err;
  }
};
